module.exports = __webpack_public_path__ + "static/media/10450_Rectangular_Grass_Patch_v1_Diffuse.11fdb98f.jpeg";